import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServiceRemoteActionBuilder } from '../service-remote-action-builder';
import { Servicejob } from 'src/app/_model/servicejob';
import { TrannsactionResult } from 'plugins/lbs-peripherals/dist/esm';

export class PaymentReceiptRemoteActionBuilder extends ServiceRemoteActionBuilder {
  constructor(
    sjob: Servicejob,
    transaction: TrannsactionResult,
    appService: AppService,
    credentialsService: CredentialsService,
    logger?: LoggingService,
  ) {
    super(
      appService,
      credentialsService,
      {
        endpoint: 'paymentreceipt',
        data: {
          objid: sjob.id.imsId,
          objref: sjob.id.objRef,
          tourid: sjob.tour?.id,
          amount: transaction.amount,
          ref: transaction.ref,
          cardtype: transaction.cardBrandName,
          merchantreceipt: transaction.merchantReceipt,
          customerreceipt: transaction.customerReceipt,
        },
        cachable: true,
        fifo: false,
        authenticationRequired: true,
        shortLabel: 'PAYMENT-REMOTE-ACTION-BUILDER.RA.SHORT.LABEL',
        shortLabelTranslate: true,
        longLabel: `${sjob.displayLabel}: €${transaction.amount}(${transaction.ref})`,
        longLabelTranslate: false,
      },
      [],
      async (_data: any) => {},
      logger,
    );
  }
}
